"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractTicketList = void 0;
var util_1 = require("../../util");
var noApproves = new Set(['my-tickets', 'teamless-tickets']);
function extractTicketList(query) {
    var stateStr = util_1.tryGetValue(query.state);
    var team_id = util_1.tryGetValue(query.team_id);
    var state;
    switch (stateStr) {
        case 'open':
        case 'closed':
            state = stateStr;
            break;
        case 'approval':
            state = team_id && noApproves.has(team_id) ? 'open' : stateStr;
            break;
    }
    return {
        name: 'ticket_list',
        state: state,
        team_id: team_id,
    };
}
exports.extractTicketList = extractTicketList;
